import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField/index';
import Dialog from '@material-ui/core/Dialog/index';
import DialogActions from '@material-ui/core/DialogActions/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DialogTitle from '@material-ui/core/DialogTitle/index';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import Grid from "@material-ui/core/Grid";

import Divider from "@material-ui/core/Divider";
import DraggableModal from "../../../../Include/DraggableModal/DraggableModal";
import {FieldsJs} from "../../../../../settings/General/General";
import Slide from "@material-ui/core/Slide";
import {PromocionService} from "../../../../../services/_Cat/PromocionService/PromocionService";
import {
	BotonAccionAbrirModal,
	BotonAccionFooterModal,
	TituloHeaderModal
} from "../../../../Include/MiniComponents/GlobalComponent";
import MDDatePicker from "../../../../Include/MDDatePicker/MDDatePicker";
import {DateFormat} from "../../../../../settings/DateFormat/DateFormat";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import {DateRangeOutlined} from "@material-ui/icons";

class ModalPromocion extends Component {
	
	state = {};
	
	constructor(props) {
		super(props);
		
		this.state = {
			modal: {
				open: false
			},
			
			tipo: props.tipo,
			
			id_cat_promocion: (props.item || {}).id_cat_promocion,
			promocion: '',
			codigo: '',
			activo: true,
			
			fecha_periodo_inicio: null,
			fecha_periodo_fin: null,
		};
	}
	
	handleChange = (e, variable, campo, date, input) => {
		FieldsJs.HandleChange(e, variable, campo, date, input, (r) => this.setState({
			[r.name]: r.value
		}));
	};
	
	changeValue = (arr_name__key, var_name, var_value) => {
		FieldsJs.ChangeValue(arr_name__key, var_name, var_value, (r) => this.setState({
			[r.name]: r.value
		}), this.state);
	};
	
	closeModal = () => {
		this.setState({
			modal: {
				open: false
			}
		});
	};
	
	close = () => {
		this.closeModal();
	};
	
	openModal = () => {
		const props = this.props;
		this.setState({
			modal: {
				open: true
			}
		});
		console.log(this.state, props);
	};
	
	open = () => {
		this.init().then(r => {
			setTimeout(() => this.openModal());
		}).catch(e => {
			console.log(e);
		});
	};
	
	RefreshInit = () => {
		this.init();
	};
	
	init = () => {
		return new Promise((resolve) => {
			resolve(true);
		});
	};
	
	save = () => {
		if (this.state.id_cat_promocion > 0) {
			PromocionService.Modificar(this.state).then((response) => {
				this.close();
				this.props.RefreshList();
				this.props.showSnackBars('success', response.mensaje);
			}).catch((error) => {
				this.props.showSnackBars('error', error.mensaje);
			});
		} else {
			PromocionService.Agregar(this.state).then((response) => {
				this.close();
				this.props.RefreshList(response.data);
				this.props.showSnackBars('success', response.mensaje);
			}).catch((error) => {
				this.props.showSnackBars('error', error.mensaje);
			});
		}
	};
	
	add = () => {
		console.log(this.props);
		this.setState({
			id_cat_promocion: '',
			promocion: '',
			fecha_periodo_inicio: null,
			fecha_periodo_fin: null,
			codigo: '',
			activo: true,
		});
		this.open();
	};
	
	edit = () => {
		const {item} = this.props;
		console.log(this.props);
		this.setState({
			id_cat_promocion: item.id_cat_promocion || '',
			promocion: item.promocion || '',
			fecha_periodo_inicio: item.fecha_periodo_inicio || '',
			fecha_periodo_fin: item.fecha_periodo_fin || '',
			codigo: item.codigo || '',
			activo: (item.activo === 1),
		});
		this.open();
	};
	
	view = () => {
		const {item} = this.props;
		console.log(this.props);
		this.setState({
			id_cat_promocion: item.id_cat_promocion || '',
			promocion: item.promocion || '',
			fecha_periodo_inicio: item.fecha_periodo_inicio || '',
			fecha_periodo_fin: item.fecha_periodo_fin || '',
			codigo: item.codigo || '',
			activo: (item.activo === 1),
		});
		this.open();
	};
	
	render() {
		
		let funcion;
		
		switch (this.state.tipo) {
			case 'edit':
				funcion = this.edit;
				break;
			case 'add':
				funcion = this.add;
				break;
			case 'view':
				funcion = this.view;
				break;
			default:
				funcion = () => {
				};
		}
		
		return (
			<div>
				
				{this.props.componente ? (
					<Fragment>
						<span
							style={{cursor: 'pointer'}}
							children={this.props.componente}
							onClick={() => funcion()}
						/>
					</Fragment>
				) : (
					<BotonAccionAbrirModal
						id={this.state.id_cat_promocion}
						tipo={this.state.tipo}
						onClick={() => funcion()}
					/>
				)}
				
				<Dialog open={this.state.modal.open} onClose={() => this.close()} PaperComponent={DraggableModal}
				        disableEscapeKeyDown disableBackdropClick maxWidth={'sm'} fullWidth={true} scroll={'paper'}
				        transition={<Slide direction="up"/>} aria-labelledby="scroll-dialog-title"
				>
					
					<DialogTitle>
						<TituloHeaderModal
							tipo={this.state.tipo}
							titulo={'Promoción'}
						/>
					</DialogTitle>
					
					<DialogContent>
						
						<Grid container spacing={1}>
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								
								<TextField
									autoFocus
									margin="dense"
									name="promocion"
									label="Promoción"
									type="text"
									fullWidth
									defaultValue={this.state.promocion}
									onChange={this.handleChange}
									disabled={this.state.tipo === 'view'}
								/>
							
							</Grid>
							
							<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
								
								<TextField
									multiline
									margin="dense"
									name="codigo"
									label="Código"
									type="text"
									fullWidth
									defaultValue={this.state.codigo}
									onChange={this.handleChange}
									disabled={this.state.tipo === 'view'}
								/>
							
							</Grid>
							
							<Grid item xs={12} sm={12} md={6} lg={6} xl={6} align={'left'}>
								<div style={{marginTop: '5px'}}>
									<MDDatePicker
										type={'range'}
										component={(
											<TextField
												fullWidth
												label="Periodo"
												value={(this.state.fecha_periodo_inicio && this.state.fecha_periodo_fin) ? (DateFormat.FormatText(this.state.fecha_periodo_inicio) + " al " + DateFormat.FormatText(this.state.fecha_periodo_fin)) : ''}
												readOnly
												InputProps={{
													endAdornment: (
														<InputAdornment position="center">
															<IconButton aria-label="Periodo">
																<DateRangeOutlined/>
															</IconButton>
														</InputAdornment>
													)
												}}
											/>
										)}
										startDate={this.state.fecha_periodo_inicio}
										endDate={this.state.fecha_periodo_fin}
										onChange={(range) => {
											this.setState({
												fecha_periodo_inicio: range.startDate,
												fecha_periodo_fin: range.endDate,
											});
										}}
									/>
								</div>
							</Grid>
						
						</Grid>
						
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
							
							<FormGroup row className={'margin-3-L'}>
								<FormControlLabel
									control={
										<Checkbox
											type="checkbox"
											disabled={this.state.tipo === 'view'}
											onChange={this.handleChange}
											color="primary"
											name='activo'
											checked={this.state.activo}
											value="activo"
										/>
									}
									label={'Activo'}
								/>
							</FormGroup>
						
						</Grid>
					
					</DialogContent>
					
					<Divider/>
					
					<DialogActions>
						
						<BotonAccionFooterModal
							id={this.state.id_cat_promocion}
							tipo={this.state.tipo}
							close={this.close}
							save={this.save}
						/>
					
					</DialogActions>
				
				</Dialog>
			
			</div>
		);
	}
}

ModalPromocion.propTypes = {
	componente: PropTypes.element,
	tipo: PropTypes.string.isRequired,
	item: PropTypes.object.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
};

export default ModalPromocion;
